import { Translate } from 'react-admin';
import { ChoiceProps } from 'types/form.type';

export const getYesNoOrAnyChoices = (translate: Translate): ChoiceProps => [
  { id: 'YES', name: translate('shared.yes') },
  { id: 'NO', name: translate('shared.no') },
  { id: 'ANY', name: translate('shared.any') },
];
